import { HappContainer } from 'components/CustomStyledComponents/CustomStyledComponents';
import { Row, Col } from 'react-bootstrap';
import newLogo from 'assets/img/new-happ-logo.png';
import { LoadingSpinner } from 'components/Loaders/LoadingSpinner';
import StepperComponent from 'components/Stepper/StepperComponent';
import WelcomeComponent from 'components/Welcome/WelcomeComponent';
import ProspectSearch from 'components/ProspectSearch/ProspectSearch';
import useSelfEnrollment from 'hooks/selfEnrollment/useSelfEnrollment';
import ProspectForm from 'components/ProspectForm/ProspectForm';
import RegisterSuccess from 'components/RegisterSuccess/RegisterSuccess';
import ConsentDataInput from 'components/ConsentDataInput/ConsentDataInput';
import ConsentCodeInput from 'components/ConsentCodeInput/ConsentCodeInput';
import SelfRegisterFinish from 'components/SelfRegisterFinish/SelfRegisterFinish';

const initState = {
  prospect: null,
  loading: false,
  error: null,
  step: 'welcome',
  subStep: 'welcome',
  prospectExists: false,
  missingConsent: false,
  alertData: null,
  codeError: null,
  serverError: null,
  consentPreview: null
};

const SelfEnrollmentView = () => {
  const {
    prospect, 
    loading, 
    error,
    codeError,
    serverError,
    step,
    subStep,
    prospectExists,
    missingConsent,
    handleSearch,
    consentPreview,
    handleBeginRegister,
    handleProspectExists,
    handleSubmitForm,
    handleBackToSearch,
    handleToConsent,
    handleToInputCode,
    handleValidateCode,
    handlePhoneChange,
    handleEmailChange,
    handleRequestNewCode,
    handleCloseSearchAlert,
    handleMissingConsent,
    handleConsentPreview,
    handleCleanServerError
  } = useSelfEnrollment(initState);

  return (
    <HappContainer>
      {loading && <LoadingSpinner />}
      <Row>
        <Col className='text-center m-4'>
          <img src={newLogo} alt="logo" style={{height:'60px'}} />
        </Col>
      </Row>
      <Row>
        <Col>
          <StepperComponent
            activeStep={step}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          {step === 'welcome' && 
          <WelcomeComponent 
            handleNextStep={handleBeginRegister}
          />
          }
          {step === 'prospect-register' && subStep === 'prospect-search' &&
          <ProspectSearch 
            handleSearch={handleSearch}
            prospectExists={prospectExists}
            missingConsent={missingConsent}
            handleProspectExists={handleProspectExists}
            handleMissingConsent={handleMissingConsent}
            handleCloseAlert={handleCloseSearchAlert}
          />
          }
          {step === 'prospect-register' && subStep ==='prospect-form' &&
          <ProspectForm 
            dni={prospect.dni}
            onSubmitForm={handleSubmitForm}
            onBackpressed={handleBackToSearch}
            serverError={serverError}
            onCleanError={handleCleanServerError}
          />
          }
          {step === 'prospect-register' && subStep === 'register-success' &&
          <RegisterSuccess 
            onToConsent={handleToConsent}
          />
          }
          {step === 'consent' && subStep === 'consent-data-input' &&
          <ConsentDataInput 
            onContinue={handleToInputCode}
            phone={prospect.phone}
            email={prospect.email}
            setPhone={handlePhoneChange}
            setEmail={handleEmailChange}
            onPreview={handleConsentPreview}
            consentPreview={consentPreview}
            serverError={serverError}
            onCleanError={handleCleanServerError}
          />
          }
          {step === 'consent' && subStep ==='consent-code-input' &&
          <ConsentCodeInput 
            onValidateCode={handleValidateCode}
            onReSendCode={handleRequestNewCode}
            codeError={codeError}
            errors={{}}
          />
          }
          {step === 'finish' && subStep === 'finish-success' &&
          <SelfRegisterFinish />
          }
        </Col>
      </Row>
      {error && <p>{error}</p>}
      {prospect && <p>{prospect.name}</p>}
    </HappContainer>
  );
}

export default SelfEnrollmentView;